import { nanoid } from 'nanoid';
import fetch from 'node-fetch';
import { Origin } from '../../types/distribution';
import { ComponentError, JoiErrorResponse } from '../../types/misc';
import emptyStringToUndefined from '../emptyStringToUndefined';

interface CreateOriginResponse {
    success: boolean,
    origin?: Origin,
    errors: ComponentError[]
}

const createOrigin = async (token: string, distributionName: string, origin: Origin): Promise<CreateOriginResponse> => {
    const response = await fetch(`${process.env.REACT_APP_ADN_MANAGEMENT_BASE_URL}/v1/distributions/${distributionName}/origins`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(emptyStringToUndefined(origin))
    });

    if (response.status === 400) {
        const error = (await response.json());

        // not a joi error
        if (!error.validation) {
            return {
                success: false,
                errors: [{
                    message: error.message,
                    path: '',
                    uiId: nanoid()
                }]
            };
        }

        const joiError = error as JoiErrorResponse;
        return {
            success: false,
            errors: joiError.validation.errors
        };
    }

    if (!response.ok) {
        throw new Error(`Unexpected error when creating an origin. Got status code ${response.status}`);
    }

    return {
        success: true,
        origin: await response.json(),
        errors: []
    };
};

export default createOrigin;
